import React from "react";

import { Wrapper, Container, TextWrap, Title, Image } from "./style";

import { useSelector } from "react-redux";

const selector = state => ({
  component: state.component
});

export default function NascemosParaFacilitar() {

  const { component } = useSelector(selector);
  const {
    tagTitle,
    tagTitleColor,
    tagImg,
    tagBgColor
  } = component;
  return (
    <Wrapper style={{ backgroundColor: tagBgColor }}>
      <Container>
        <Image src={`https://` + tagImg} />
        <TextWrap>
          <Title color={tagTitleColor}>{tagTitle}</Title>
        </TextWrap>
      </Container>
    </Wrapper>
  );
}
